/* calculates the time between today's date and the date provided, returns an object with the total
and the breakdown of days, hours, minutes, seconds. Useful for countdown timers or to check if a
date is within a certain range compared to today such as "within 48 hours" */
const getTimeRemaining = (endTime: Date, startTimeInt?: number) => {

	const adjustedEndTime = new Date(endTime);

	// Number.isNaN does not work for dates
	// eslint-disable-next-line no-restricted-properties
	if (window.isNaN(adjustedEndTime.getTime())) {

		return {
			total: 0,
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0
		};

	}

	// Set time to the very last second of the day if no time is indicated
	if (adjustedEndTime.getHours() === 0 && adjustedEndTime.getMinutes() === 0 && adjustedEndTime.getSeconds() === 0) {

		adjustedEndTime.setHours(23, 59, 59, 0);

	}

	const total = startTimeInt ? adjustedEndTime.getTime() - startTimeInt : adjustedEndTime.getTime() - Date.now();
	const seconds = Math.floor((total / 1000) % 60);
	const minutes = Math.floor((total / 1000 / 60) % 60);
	const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
	const days = Math.floor(total / (1000 * 60 * 60 * 24));

	return {
		total,
		days,
		hours,
		minutes,
		seconds
	};

};
export default getTimeRemaining;
